import React, { ReactElement } from 'react';
import { Route, Routes, useParams } from 'react-router';
import { NotFound } from '../loadable-elements/NotFound';
import ConsumerTestGuide from '../pages/ConsumerTestGuide/ConsumerTestGuide';
import TestedProductPage from '../pages/ConsumerTestGuide/TestedProductPage/TestedProductPage';

const TestedProductRoute = (): ReactElement => {
  const { testSlug, guideSlug } = useParams<{ testSlug: string; guideSlug: string }>();

  if (!testSlug) {
    return <NotFound />;
  }

  return <TestedProductPage testSlug={testSlug} guideSlug={guideSlug} />;
};

export default TestedProductRoute;

export const ConsumerTestRouter = (): ReactElement => (
  <Routes>
    {/* Render a specific consumer test guide */}
    <Route path=":slug" element={<ConsumerTestGuide />} />

    {/* Route for TestedProductPage */}
    <Route path=":guideSlug/:testSlug" element={<TestedProductRoute />} />

    {/* Fallback for invalid paths */}
    <Route path="*" element={<NotFound />} />
  </Routes>
);
